module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/hero_mob-51865ef08ab349e5d041d058b403e197.jpg";